import { SafePromise } from "./SafePromise"

export async function WithCleanup<T>(
  value: Promise<T>,
  close: (error: Error | undefined) => void
): Promise<T> {
  const maybe = await SafePromise(value)

  void close(maybe.error)

  if (maybe.error) {
    throw maybe.error
  }

  return maybe.value
}
